(function () {
  "use strict";

  /* ─── Configuration ─────────────────────────────────────────────────────
     BASE_CONFIGURATOR_URL   Iframe target. The Shopify product id is
                             appended to it, e.g. .../customizein3d/1234567890.

     CTA_CONTAINER_SELECTORS Selectors (checked in order) for the element
                             that wraps the existing CTA buttons (Add to
                             cart / Buy now / Enquire now). The "Customize
                             in 3D" button is inserted immediately AFTER
                             whichever one matches first on the page.

                             The defaults below cover common Shopify theme
                             markup (Dawn and Dawn-derived themes). If the
                             button doesn't land in the right place on this
                             store's product page, inspect the CTA buttons'
                             wrapper element and add/adjust a selector here.
  ────────────────────────────────────────────────────────────────────────*/
  var BASE_CONFIGURATOR_URL = "https://dashsquare.ovlapps.com/customizein3d";
  var WRAPPER_ID = "configuratorWrapper";
  var IFRAME_ID = "configuratorIframe";
  var LOADER_ID = "sv-loader";
  var PRODUCT_LOADER_ID = "sv-product-loader";
  var BUTTON_ID = "opus-customize-in-3d-btn";

var ALLOWED_PRODUCT_IDS = ["9105366810787", "9105369563299", "9105369596067", "9105369628835", "9105369661603", "9105369694371", "9105369727139", "9105370513571", "9031065698467", "9105369792675", "9105369825443", "9031065141411", "9105370054819", "9105370087587", "9031064813731", "9105369923747", "9105369956515", "9105369989283", "9105370022051", "9031064256675", "9105370546339", "9105370120355", "9105370153123", "9031065239715", "9105369563299", "9105370218659", "9031064420515", "9031065731235", "9105369858211", "9105369890979", "9105370579107", "9105370513571", "9105370480803", "9105370448035", "9105370382499", "9029999427747", "9025187414179", "9105370513571", "9105370349731", "9105370316963", "9031064387747", "9105370284195", "9034581704867", "9031066747043", "9031071596707", "9031064617123", "9031065665699", "9031064453283"];
  var CTA_CONTAINER_SELECTORS = [
    "a[href*=\"wa.me\"]",
    ".product-form__buttons",
    ".product-form__cart",
    ".product-form__cart-submit",
    ".product__actions",
    "[data-product-form]",
    "form[action*=\"/cart/add\"]"
  ];

  // Fallback selectors for the product's main image, checked in order, used
  // only if the og:image meta tag (set by Shopify on every product page) is
  // missing.
  var PRODUCT_IMAGE_SELECTORS = [
    ".product__media img",
    ".product-media-container img",
    ".product-single__photo img",
    ".product__photo img",
    "[data-product-featured-image] img"
  ];

  var _loadHandler = null;
  var _hideTimer = null;
  var PRODUCT_LOADER_HIDE_DELAY = 2500;

  /* ─── Resolve the current product's main image ───────────────────────── */
  function getProductMainImageUrl() {
    var ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage && ogImage.content) return ogImage.content;

    for (var i = 0; i < PRODUCT_IMAGE_SELECTORS.length; i++) {
      var img = document.querySelector(PRODUCT_IMAGE_SELECTORS[i]);
      var src = img && (img.currentSrc || img.src);
      if (src) return src;
    }
    return null;
  }

  /* ─── Product-specific loader (#sv-product-loader in opus_shopify.html) ─
     Shown instead of the generic #sv-loader when opening the configurator
     straight to a single product. ──────────────────────────────────────── */
  function _showProductLoader() {
    var productLoader = document.getElementById(PRODUCT_LOADER_ID);
    if (!productLoader) return;

    var logo = productLoader.querySelector(".sv-loader-logo");
    var imageUrl = getProductMainImageUrl();
    if (logo && imageUrl) logo.src = imageUrl;

    var loader = document.getElementById(LOADER_ID);
    if (loader) loader.classList.add("sv-hidden");
    productLoader.classList.remove("sv-hidden");
  }

  function _hideProductLoader() {
    var productLoader = document.getElementById(PRODUCT_LOADER_ID);
    if (productLoader) productLoader.classList.add("sv-hidden");
  }

  function openConfiguratorWithUrl(url) {
    var wrapper = document.getElementById(WRAPPER_ID);
    var iframe = document.getElementById(IFRAME_ID);
    if (!wrapper || !iframe) {
      console.error("[opus_shopify_product_button] #" + WRAPPER_ID + " / #" + IFRAME_ID + " not found on page — is opus_shopify.js's wrapper markup present?");
      return;
    }
    if (iframe.src !== url) {
      if (_loadHandler) {
        iframe.removeEventListener("load", _loadHandler);
        _loadHandler = null;
      }
      if (_hideTimer) {
        clearTimeout(_hideTimer);
        _hideTimer = null;
      }
      _showProductLoader();
      iframe.src = url;
      _loadHandler = function () {
        _loadHandler = null;
        _hideTimer = setTimeout(function () { _hideProductLoader(); _hideTimer = null; }, PRODUCT_LOADER_HIDE_DELAY);
      };
      iframe.addEventListener("load", _loadHandler, { once: true });
    }
    wrapper.classList.add("sv-open");
    document.body.style.overflow = "hidden";
  }

  /* ─── Resolve the current product's Shopify id ──────────────────────── */
  function getShopifyProductId() {
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id) {
        return String(window.ShopifyAnalytics.meta.product.id);
      }
    } catch (e) {}

    try {
      if (window.meta && window.meta.product && window.meta.product.id) {
        return String(window.meta.product.id);
      }
    } catch (e) {}

    var el = document.querySelector("[data-product-id]");
    if (el && el.dataset.productId) return el.dataset.productId;

    return null;
  }

  function isProductPage() {
    return /\/products\//.test(window.location.pathname);
  }

  function findCtaContainer() {
    for (var i = 0; i < CTA_CONTAINER_SELECTORS.length; i++) {
      var el = document.querySelector(CTA_CONTAINER_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  /* ─── Build + inject the button ──────────────────────────────────────── */
  function createButton(shopifyId) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.id = BUTTON_ID;
    // Reuse the theme's own button classes so size/padding match the
    // "Enquire Now" button exactly; opus_shopify.css only overrides color.
    btn.className = "button button--primary opus-customize-in-3d-btn";
    btn.style.cssText = "display: inline-flex; text-decoration: none;";

    // Inner frame: holds the icon/label and the "Try now" badge in a single
    // centered row. Carries the solid fill + inner border; the outer
    // <button> is the second, larger border ring, so the two together read
    // as a "frame inside a frame".
    var innerFrame = document.createElement("span");
    innerFrame.className = "opus-inner-frame";
    innerFrame.style.cssText = "position: relative; display: inline-flex; align-items: center; justify-content: center; text-align: center; gap: 8px; width: 100%;";

    var icon = document.createElement("span");
    icon.setAttribute("aria-hidden", "true");
    icon.style.cssText = "display: inline-flex; flex-shrink: 0; line-height: 0;";
    icon.innerHTML =
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M12 2L21 7L12 12L3 7Z" fill="currentColor" fill-opacity="1"/>' +
      '<path d="M21 7L21 17L12 22L12 12Z" fill="currentColor" fill-opacity="0.65"/>' +
      '<path d="M3 7L12 12L12 22L3 17Z" fill="currentColor" fill-opacity="0.85"/>' +
      "</svg>";
    innerFrame.appendChild(icon);

    var label = document.createElement("span");
    label.textContent = "Customize in 3D";
    innerFrame.appendChild(label);

    var badge = document.createElement("span");
    badge.className = "opus-try-now-badge";
    badge.setAttribute("aria-hidden", "true");
    badge.innerHTML =
      '<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M13 2L3 14H11L10 22L21 9H13L13 2Z"/>' +
      "</svg>" +
      '<span class="opus-try-now-badge-text">Try now</span>';
    innerFrame.appendChild(badge);

    btn.appendChild(innerFrame);

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      openConfiguratorWithUrl(BASE_CONFIGURATOR_URL + "/" + shopifyId);
    });
    return btn;
  }

  function injectButton() {
    if (!isProductPage()) return;
    if (document.getElementById(BUTTON_ID)) return;

    var shopifyId = getShopifyProductId();
    if (!shopifyId) return;
    if (ALLOWED_PRODUCT_IDS.indexOf(shopifyId) === -1) return;

    var container = findCtaContainer();
    if (!container) return;

    container.insertAdjacentElement("afterend", createButton(shopifyId));
  }

  /* ─── Initialise ─────────────────────────────────────────────────────── */
  function init() {
    injectButton();

    // Themes commonly re-render the CTA area (variant change, dynamic
    // checkout button, section re-render) — keep watching so the button
    // isn't lost. injectButton() no-ops instantly once the button exists.
    var observer = new MutationObserver(injectButton);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
